import React from 'react';
import './Home.css';

// Placeholder images - replace these with your actual image assets
const artworkImages = {
  artwork01: "/images/artwork-01.png",
  artwork02: "/images/artwork-02.png", 
  artwork03: "/images/artwork-03.png",
  artwork04: "/images/artwork-04.png",
  artwork05: "/images/artwork-05.png"
};


const Home = () => {
  return (
    <div className="home-container">
      <div className="body-container">
        
        {/* First Artwork - Full Width */}
        <div className="item-container">
          <div className="artwork-card">
            <div className="artwork-wrapper artwork-01">
              <img 
                src={artworkImages.artwork01} 
                alt="Isometric 3D City Illustration"
                className="artwork-image"
              />
            </div>
          </div>
        </div>

        {/* Second Artwork - Full Width */}
        <div className="item-container">
          <div className="artwork-card">
            <div className="artwork-wrapper artwork-02">
              <img 
                src={artworkImages.artwork02} 
                alt="Data Visualization Dashboard"
                className="artwork-image"
              />
            </div>
          </div>
        </div>

        {/* Third Artwork - Left Aligned */}
        <div className="item-container item-left">
          <div className="artwork-card">
            <div className="artwork-wrapper artwork-03">
              <img 
                src={artworkImages.artwork03} 
                alt="Business Process Illustration"
                className="artwork-image"
              />
            </div>
          </div>
        </div>

        {/* Fourth Artwork - Right Aligned */}
        <div className="item-container item-right">
          <div className="artwork-card">
            <div className="artwork-wrapper artwork-04">
              <img 
                src={artworkImages.artwork04} 
                alt="Technology Innovation Graphic"
                className="artwork-image"
              />
            </div>
          </div>
        </div>

        {/* Fifth Artwork - Centered Narrow */}
        <div className="item-container item-narrow">
          <div className="artwork-card">
            <div className="artwork-wrapper artwork-05">
              <img 
                src={artworkImages.artwork05} 
                alt="Mobile App Design Process"
                className="artwork-image"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Home;